/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  function  switchImagesWithSelectedColor(){
    var selectedColor;
    if (swatchMode) {
      selectedColor = document.querySelector('.ColorSwatch__Radio:checked').value.trim();
     
      document.querySelector('.Product__Info .ProductForm__SelectedValue').innerText = selectedColor;
    }
    else {
      selectedColor = document.querySelector('.ProductForm__Variants .ProductForm__SelectedValue').innerText;
      document.querySelector('.Product__Info .ProductForm__SelectedValue').innerText = selectedColor;
    }
     // Hide all images except selected color
    document.querySelectorAll('.Product__SlideItem').forEach(function(slideItem) {
      var imageMatchesAlt = slideItem.querySelector('img').alt.toLowerCase().indexOf(selectedColor.toLowerCase()) !== -1;
      slideItem.classList.add('hidden');
      if (imageMatchesAlt) {
        slideItem.classList.remove('hidden');
      }
    });
     document.querySelectorAll('.Product__SlideshowNavImage').forEach(function(thumbnail) {
      var imageMatchesAlt = thumbnail.querySelector('img').alt.toLowerCase().indexOf(selectedColor.toLowerCase()) !== -1;
      thumbnail.classList.add('hidden');
      if (imageMatchesAlt) {
        thumbnail.classList.remove('hidden');
      }
    });
    // Hide all dota except selected color
    document.querySelectorAll('.Product__SlideshowMobileNav .flickity-page-dots .dot').forEach(function(dot) {
      console.log(dot)
      var dotMatchesAlt = dot.dataset.imageAlt.toLowerCase().indexOf(selectedColor.toLowerCase()) !== -1;
      dot.classList.add('hidden');
      if (dotMatchesAlt) {
        dot.classList.remove('hidden');
      }
    });
  }
   var swatchMode = document.querySelectorAll('.ColorSwatch__Radio:checked').length > 0;
   var isProductPage = location.pathname.indexOf('/products/') !== -1;
  
  if(isProductPage){
                                                                                               
     switchImagesWithSelectedColor();

  }
  if (swatchMode) {
      document.querySelectorAll('.ColorSwatch__Radio').forEach(function(colorSwatch) {
        colorSwatch.onclick = switchImagesWithSelectedColor;
      });
    }
})();